import PalletRow from '../../../kosherTeudot/Components/PalletRow'
import { IPalletListWithDetails } from '../../../../../../modules/API/Pallets/models/palletList'

type Props = {
  pallet: IPalletListWithDetails
}

const noop = () => {}

/** Read-only display of the found pallet, reusing the redesigned PalletRow card. */
const FoundPalletCard = ({ pallet }: Props) => (
  <PalletRow
    {...pallet}
    isAllowToEdit={false}
    handleSelectPallet={noop}
    addProduct={noop}
    deleteProduct={noop}
  />
)

export default FoundPalletCard
